module.exports = __webpack_public_path__ + "media/components/footer/static/icon__instagram-b4d7217d6fd743b030657719431233e1.svg";